export default class FlexiSuggestModel {
    constructor() {
        this.id = 0;
        this.name = "";
        this.avatar = "";
    }
}
